import React, { useState } from 'react';
import _get from 'lodash/get';

// Components
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import AttributeMenu from './AttributeMenu';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import CreateAttributeDialog from 'components/Mappings/CreateAttributeDialog';

// Styles
import classNames from 'classnames';
import withStyles from '@material-ui/core/styles/withStyles';
import { defineStyles, Classes } from 'styles/defineStyles';

const styles = defineStyles(theme => {
  return {
    displayValue: {
      height: 38,
      padding: theme.spacing(1),
      fontSize: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      transition: 'backgroundColor .4s',
      backgroundColor: theme.palette.common.white,
      borderBottom: `1px solid ${theme.palette.text.secondary}`,
      '&:hover': {
        backgroundColor: theme.palette.grey[100],
      },
    },
    dropdownIcon: {
      color: theme.palette.text.secondary,
    },

    popperRoot: {
      zIndex: theme.zIndex.surface,
    },
    paperRoot: {
      overflow: 'hidden',
    },
  };
});

interface Props {
  displayValue: string;
  onSelectAttribute: (attribute: any) => void;
  selectedDestinations: string[];
  isCreateAttributeDialogOpen: boolean; // container
  classes: Classes<typeof styles>; // HOC
}

const AttributeSelector = (props: Props) => {
  const {
    classes,
    displayValue,
    onSelectAttribute,
    isCreateAttributeDialogOpen,
    selectedDestinations,
  } = props;

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : e.currentTarget);
  };

  function handleSelectAttribute(newAttribute: any) {
    onSelectAttribute(newAttribute);
    setAnchorEl(null);
  }

  function handleClickAway() {
    if (!isCreateAttributeDialogOpen) {
      setAnchorEl(null);
    }
  }

  return (
    <>
      <div onClick={handleToggle} className={classes.displayValue}>
        {displayValue || 'Not Mapped - Click to Assign'}
        <ArrowDropDownIcon className={classes.dropdownIcon} />
      </div>
      <Popper
        open={!!anchorEl}
        anchorEl={anchorEl}
        transition
        disablePortal
        className={classes.popperRoot}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'center top' }}>
            <ClickAwayListener onClickAway={handleClickAway}>
              <Paper elevation={2} className={classes.paperRoot}>
                <AttributeMenu
                  onSelectAttribute={handleSelectAttribute}
                  onClose={handleToggle}
                  selectedDestinations={selectedDestinations}
                />
              </Paper>
            </ClickAwayListener>
          </Grow>
        )}
      </Popper>
      {!!anchorEl && <CreateAttributeDialog onCreate={handleSelectAttribute} />}
    </>
  );
};

export default withStyles(styles)(AttributeSelector);
